/* Filtro da coleção da ANINA (seção anina-filtro-colecao). */
(() => {
  if (customElements.get('anina-filtro')) return;

  const sem = (t) =>
    String(t || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .trim();
  const chave = (t) => sem(t).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const esc = (t) =>
    String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const lista = (t) =>
    String(t || '')
      .split(';')
      .map((x) => x.trim())
      .filter(Boolean);
  const plural = (n) => `${n} ${n === 1 ? 'perfume' : 'perfumes'}`;
  const celular = () => window.matchMedia('(max-width: 749px)').matches;
  const reduzir = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* No Ritual a página rola dentro de .page-wrapper, não na janela */
  const rolagem = () => {
    const w = document.querySelector('.page-wrapper');
    if (w && /(auto|scroll)/.test(getComputedStyle(w).overflowY) && w.scrollHeight > w.clientHeight) return w;
    return document.scrollingElement || document.documentElement;
  };

  /* Ícones de traço fino para as opções */
  const SVG = (d) => `<svg viewBox="0 0 24 24" aria-hidden="true">${d}</svg>`;
  const I = {
    sol: SVG('<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4"/>'),
    broto: SVG('<path d="M12 21v-8"/><path d="M12 13c0-4.5 3-7.5 8-7.5 0 5-3 8-8 7.5z"/><path d="M12 15.5c0-3.5-2.3-5.5-6.5-5.5 0 4 2.4 6 6.5 5.5z"/>'),
    folha: SVG('<path d="M5 19c0-8 6-14 14-14 0 8-6 14-14 14z"/><path d="M5 19l8-8"/>'),
    neve: SVG('<path d="M12 2.5v19M3.8 7.2l16.4 9.6M3.8 16.8l16.4-9.6"/><path d="M9.3 4.3 12 6l2.7-1.7M9.3 19.7 12 18l2.7 1.7"/>'),
    lua: SVG('<path d="M19.5 14.5A7.5 7.5 0 1 1 9.5 4.5a6 6 0 0 0 10 10z"/>'),
    nuvem: SVG('<path d="M7 18.5h10a3.8 3.8 0 0 0 .4-7.6 5.2 5.2 0 0 0-10-.9A4.3 4.3 0 0 0 7 18.5z"/>'),
  };
  const ICONE = {
    Primavera: I.broto,
    Verão: I.sol,
    Outono: I.folha,
    Inverno: I.neve,
    Dia: I.sol,
    Noite: I.lua,
    'Clima quente': I.sol,
    'Clima ameno': I.nuvem,
    'Clima frio': I.neve,
  };

  const FAMILIAS = [
    'Floral', 'Oriental', 'Amadeirado', 'Aromático', 'Frutado', 'Fougère', 'Cítrico', 'Especiado',
    'Almiscarado', 'Chipre', 'Aquático', 'Baunilha', 'Gourmand', 'Couro', 'Âmbar', 'Verde', 'Aldeídico',
  ];
  const FAMILIA_DE = Object.fromEntries(FAMILIAS.map((f) => [sem(f), f]));

  /* Etapas do "Filtrar por uso". valores(p) = o que o perfume tem naquela etapa. */
  const ETAPAS = [
    {
      id: 'estacao',
      titulo: 'Estação',
      texto: 'Em que época do ano você vai usar? Pode marcar mais de uma.',
      ordem: ['Primavera', 'Verão', 'Outono', 'Inverno'],
      valores: (p) => lista(p.e),
    },
    {
      id: 'horario',
      titulo: 'Horário',
      texto: 'De dia, à noite ou nos dois.',
      ordem: ['Dia', 'Noite'],
      valores: (p) => {
        const h = sem(p.h);
        if (h === 'dia e noite') return ['Dia', 'Noite'];
        if (h === 'dia') return ['Dia'];
        if (h === 'noite') return ['Noite'];
        return p._tags.filter((t) => t === 'Dia' || t === 'Noite');
      },
    },
    {
      id: 'clima',
      titulo: 'Clima',
      texto: 'Só aparecem os climas que combinam com as escolhas anteriores.',
      ordem: ['Clima quente', 'Clima ameno', 'Clima frio'],
      rotulo: (v) => v.replace(/^Clima\s+/i, '').replace(/^./, (c) => c.toUpperCase()),
      valores: (p) => lista(p.c),
    },
    {
      id: 'ocasiao',
      titulo: 'Ocasião',
      texto: 'Para que momento é o perfume? Pode marcar mais de uma.',
      ordem: [
        'Dia a dia', 'Trabalho', 'Encontro', 'Jantar', 'Festa / balada', 'Evento formal',
        'Ocasião especial', 'Viagem', 'Praia', 'Academia',
      ],
      valores: (p) => lista(p.o),
    },
    {
      id: 'familia',
      titulo: 'Família olfativa',
      texto: 'O estilo do cheiro. Pode marcar mais de uma.',
      ordem: FAMILIAS,
      valores: (p) => [...new Set(p._tags.map((t) => FAMILIA_DE[sem(t)]).filter(Boolean))],
    },
    {
      id: 'genero',
      titulo: 'Para quem',
      texto: 'Como a casa apresenta o perfume.',
      nota: 'Feminino e Masculino já incluem os unissex.',
      ordem: ['Feminino', 'Masculino', 'Unissex'],
      rotulo: (v) => (v === 'Unissex' ? 'Só unissex' : v),
      valores: (p) => (p.g === 'Unissex' ? ['Feminino', 'Masculino', 'Unissex'] : p.g ? [p.g] : []),
    },
  ];
  const ETAPA = Object.fromEntries(ETAPAS.map((e) => [e.id, e]));

  /* Faixas de preço (em centavos) */
  const FAIXAS = [
    { id: 'ate-800', rotulo: 'Até R$ 800', min: 0, max: 80000 },
    { id: '800-1500', rotulo: 'R$ 800 a R$ 1.500', min: 80000, max: 150000 },
    { id: '1500-2500', rotulo: 'R$ 1.500 a R$ 2.500', min: 150000, max: 250000 },
    { id: 'acima-2500', rotulo: 'Acima de R$ 2.500', min: 250000, max: Infinity },
  ];
  const FAIXA = Object.fromEntries(FAIXAS.map((f) => [f.id, f]));

  const GRUPOS = ['casa', 'preco', ...ETAPAS.map((e) => e.id)];
  const POR_PAGINA = 24;

  class AninaFiltro extends HTMLElement {
    connectedCallback() {
      this.secao = this.closest('.shopify-section');
      this.total = parseInt(this.dataset.total, 10) || 0;
      this.ordemAtual = this.dataset.ordemAtual || '';
      this.moeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: this.dataset.moeda || 'BRL' });
      this.fundo = this.querySelector('[data-fundo]');
      this.etapaEl = this.querySelector('[data-etapa]');
      this.progresso = this.querySelector('[data-progresso]');
      this.progresso.innerHTML = ETAPAS.map(() => '<li></li>').join('');

      /* Atalhos, filtros ligados e lista filtrada vão para logo depois da seção (fora da barra fixa) */
      this.abaixo = this.querySelector('[data-abaixo]');
      if (this.secao && this.abaixo) this.secao.after(this.abaixo);
      this.lista = this.abaixo.querySelector('[data-lista]');
      this.resultados = this.abaixo.querySelector('[data-resultados]');
      this.ativosEl = this.abaixo.querySelector('[data-ativos]');
      this.vazio = this.abaixo.querySelector('[data-vazio]');
      this.sugestoes = this.abaixo.querySelector('[data-sugestoes]');
      this.mais = this.abaixo.querySelector('[data-mais]');
      this.atalhos = [...this.abaixo.querySelectorAll('[data-atalho]')];

      const faixasEl = this.querySelector('[data-faixas]');
      if (faixasEl) {
        faixasEl.innerHTML = FAIXAS.map(
          (f) =>
            `<li><label class="anina-filtro__check"><input type="checkbox" value="${f.id}" data-grupo="preco"><span class="anina-filtro__check-nome">${esc(f.rotulo)}</span><span class="anina-filtro__check-num" data-num></span></label></li>`
        ).join('');
      }

      this.aplicado = this.lerUrl();
      this.rascunho = null;
      this.passo = 0;
      this.mostrando = POR_PAGINA;
      this.grade = this.acharGrade();

      this.onClick = (e) => this.clique(e);
      this.onKey = (e) => {
        if (e.key === 'Escape' && this.aberto) {
          e.preventDefault();
          this.fechar(true);
        }
      };
      this.onFora = (e) => {
        if (!this.aberto || celular()) return;
        if (!e.composedPath().includes(this.aberto.closest('.anina-filtro__item'))) this.fechar(false);
      };
      this.onPop = (e) => {
        /* Volta disparada por nós ao fechar a gaveta: só segue o que estava pendente */
        if (this.ignorarPop) {
          this.ignorarPop = false;
          clearTimeout(this.esperaPop);
          const seguir = this.depoisPop;
          this.depoisPop = null;
          seguir?.();
          return;
        }
        /* No celular, o "voltar" fecha a gaveta aberta em vez de sair da página */
        if (this.empurrou) {
          this.empurrou = false;
          if (this.aberto) {
            this.fechar(true, true);
            return;
          }
        }
        this.aplicado = this.lerUrl();
        this.mostrando = POR_PAGINA;
        this.atualizar();
      };
      this.onRolar = () => {
        if (!this.raf)
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            this.medirTopo();
          });
        /* o cabeçalho some/volta com transição: mede de novo quando ela termina */
        clearTimeout(this.fimRolar);
        this.fimRolar = setTimeout(() => this.medirTopo(), 400);
      };

      this.addEventListener('click', this.onClick);
      this.abaixo.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('pointerdown', this.onFora);
      window.addEventListener('popstate', this.onPop);
      document.addEventListener('scroll', this.onRolar, { passive: true, capture: true });
      window.addEventListener('resize', this.onRolar, { passive: true });

      this.querySelector('[data-busca-casa]')?.addEventListener('input', (e) => this.buscarCasa(e.target.value));
      this.querySelectorAll('[data-painel="casa"], [data-painel="preco"]').forEach((p) =>
        p.addEventListener('change', () => this.contarLista())
      );
      [this, this.abaixo].forEach((raiz) =>
        raiz.querySelectorAll('[data-ordem]').forEach((s) => s.addEventListener('change', (e) => this.ordenar(e.target.value)))
      );
      this.querySelectorAll('[data-alca], .anina-filtro__painel-topo').forEach((el) => this.arrastar(el));

      /* Barra grudada: um marcador antes da seção diz quando ela já descolou do lugar original */
      this.sentinela = document.createElement('div');
      this.sentinela.setAttribute('aria-hidden', 'true');
      this.sentinela.style.cssText = 'height:0;';
      this.secao?.before(this.sentinela);
      this.medirTopo();

      /* Dados: já carrega se há filtro na URL; senão, quando o navegador estiver livre ou ao passar o mouse */
      if (this.temFiltro(this.aplicado)) this.carregar().then(() => this.atualizar());
      else {
        this.atualizarBotoes();
        const pre = () => this.carregar().then(() => this.mostrarAtalhos());
        if ('requestIdleCallback' in window) requestIdleCallback(pre, { timeout: 2500 });
        else setTimeout(pre, 1200);
      }
      this.querySelector('.anina-filtro__barra').addEventListener('pointerenter', () => this.carregar(), { once: true });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.abaixo?.removeEventListener('click', this.onClick);
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('pointerdown', this.onFora);
      window.removeEventListener('popstate', this.onPop);
      document.removeEventListener('scroll', this.onRolar, { capture: true });
      window.removeEventListener('resize', this.onRolar);
      clearTimeout(this.fimRolar);
      if (this.raf) cancelAnimationFrame(this.raf);
      this.sentinela?.remove();
    }

    /* Onde termina o cabeçalho fixo do tema (ele some ao descer e volta ao subir) */
    medirTopo() {
      let topo = 0;
      let el = document.querySelector('#header-component, header-component');
      while (el && el !== document.body) {
        const pos = getComputedStyle(el).position;
        if (pos === 'sticky' || pos === 'fixed') {
          const r = el.getBoundingClientRect();
          if (r.bottom > 0 && r.height > 0) topo = Math.round(r.bottom);
          break;
        }
        el = el.parentElement;
      }
      if (topo !== this.topo) {
        this.topo = topo;
        document.documentElement.style.setProperty('--anina-filtro-topo', `${topo}px`);
      }
      if (this.sentinela) this.classList.toggle('is-colada', this.sentinela.getBoundingClientRect().top < topo - 1);
    }

    /* ---------- Dados ---------- */
    carregar() {
      if (this.dados) return this.dados;
      const base = this.dataset.dados;
      const pagina = (n) =>
        fetch(`${base}${base.includes('?') ? '&' : '?'}page=${n}`, { credentials: 'same-origin' })
          .then((r) => r.text())
          .then((t) => {
            const i = t.indexOf('ANINA_DADOS_INICIO');
            const f = t.indexOf('ANINA_DADOS_FIM');
            return JSON.parse(t.slice(i + 'ANINA_DADOS_INICIO'.length, f));
          });
      this.dados = pagina(1)
        .then(async (p1) => {
          let itens = p1.itens;
          for (let n = 2; n <= (p1.paginas || 1); n++) itens = itens.concat((await pagina(n)).itens);
          this.perfumes = itens.map((p, i) => {
            p._tags = lista(p.tg);
            p._ordem = i;
            p._v = {};
            ETAPAS.forEach((e) => (p._v[e.id] = e.valores(p)));
            return p;
          });
          return this.perfumes;
        })
        .catch((e) => {
          console.error('[anina-filtro]', e);
          this.dados = null;
          this.perfumes = [];
        });
      return this.dados;
    }

    /* ---------- Estado ---------- */
    vazioEstado() {
      return Object.fromEntries(GRUPOS.map((g) => [g, []]));
    }

    copia(s) {
      return JSON.parse(JSON.stringify(s));
    }

    temFiltro(s) {
      return Object.values(s).some((v) => v.length);
    }

    lerUrl() {
      const q = new URLSearchParams(location.search);
      const s = this.vazioEstado();
      GRUPOS.forEach((k) => {
        const v = q.get(k);
        if (v) s[k] = v.split(',').filter(Boolean);
      });
      return s;
    }

    escreverUrl() {
      const url = new URL(location.href);
      GRUPOS.forEach((k) => {
        const v = this.aplicado[k].map((x) => (k === 'preco' ? x : chave(x)));
        if (v.length) url.searchParams.set(k, v.join(','));
        else url.searchParams.delete(k);
      });
      url.searchParams.delete('page');
      const novo = url.pathname + url.search.replace(/%2C/gi, ',') + url.hash;
      try {
        if (novo !== location.pathname + location.search + location.hash) history.pushState({}, '', novo);
      } catch (e) {
        /* sem URL (ex.: página dentro de iframe): o filtro segue funcionando */
      }
    }

    /* As escolhas vindas da URL estão como chave sem acento; troca pelo valor real */
    resolver(s) {
      if (!this.perfumes) return s;
      const r = this.vazioEstado();
      const casas = [...new Set(this.perfumes.map((p) => p.b))];
      r.casa = s.casa.map((c) => casas.find((x) => chave(x) === chave(c))).filter(Boolean);
      r.preco = s.preco.filter((f) => FAIXA[f]);
      ETAPAS.forEach((e) => {
        r[e.id] = s[e.id].map((v) => e.ordem.find((x) => chave(x) === chave(v))).filter(Boolean);
      });
      return r;
    }

    combina(p, s, ignorar) {
      if (ignorar !== 'casa' && s.casa.length && !s.casa.includes(p.b)) return false;
      if (ignorar !== 'preco' && s.preco.length && !s.preco.some((f) => p.pr >= FAIXA[f].min && p.pr < FAIXA[f].max))
        return false;
      for (const e of ETAPAS) {
        if (e.id === ignorar) continue;
        const marcadas = s[e.id];
        if (marcadas.length && !marcadas.some((m) => p._v[e.id].includes(m))) return false;
      }
      return true;
    }

    filtrar(s, ignorar) {
      return (this.perfumes || []).filter((p) => this.combina(p, s, ignorar));
    }

    rotuloDe(grupo, v) {
      if (grupo === 'preco') return FAIXA[v]?.rotulo || v;
      const e = ETAPA[grupo];
      return e?.rotulo ? e.rotulo(v) : v;
    }

    /* ---------- Painéis ---------- */
    async abrir(qual) {
      if (this.aberto && this.aberto.dataset.painel === qual) return this.fechar(true);
      this.fechar(false);
      const painel = this.querySelector(`[data-painel="${qual}"]`);
      const botao = this.querySelector(`[data-abrir="${qual}"]`);
      if (!painel) return;
      this.aberto = painel;
      this.botaoAberto = botao;
      painel.hidden = false;
      painel.style.transform = '';
      botao.setAttribute('aria-expanded', 'true');
      this.fundo.hidden = false;
      this.secao?.classList.add('is-aberta');
      this.rascunho = this.copia(this.aplicado);
      if (celular()) {
        try {
          history.pushState({ aninaFiltro: true }, '', location.href);
          this.empurrou = true;
        } catch (e) {
          this.empurrou = false;
        }
        document.documentElement.style.overflow = 'hidden';
      } else {
        /* no computador, o painel cabe na parte visível da tela */
        const livre = window.innerHeight - painel.getBoundingClientRect().top - 16;
        painel.style.maxHeight = livre < 640 ? `${Math.max(280, livre)}px` : '';
      }

      const contagem = painel.querySelector('[data-contagem], [data-contagem-uso]');
      if (!this.perfumes) contagem.textContent = 'Carregando a seleção…';
      await this.carregar();
      if (this.aberto !== painel) return;
      this.rascunho = this.resolver(this.rascunho);

      if (qual === 'uso') {
        const primeiraVazia = ETAPAS.findIndex((e) => !this.rascunho[e.id].length);
        this.passo = this.temFiltro(this.rascunho) ? 0 : Math.max(0, primeiraVazia);
        this.desenharEtapa();
        painel.querySelector('.anina-filtro__opcao, [data-proxima]')?.focus({ preventScroll: true });
      } else {
        painel.querySelectorAll('[data-grupo]').forEach((i) => (i.checked = this.rascunho[i.dataset.grupo].includes(i.value)));
        this.contarLista();
        if (!celular()) (painel.querySelector('[data-busca-casa]') || painel.querySelector('[data-grupo]'))?.focus({ preventScroll: true });
      }
    }

    fechar(devolverFoco, peloVoltar) {
      if (!this.aberto) return;
      this.aberto.hidden = true;
      this.aberto.style.transform = '';
      this.botaoAberto?.setAttribute('aria-expanded', 'false');
      this.fundo.hidden = true;
      this.secao?.classList.remove('is-aberta');
      document.documentElement.style.overflow = '';
      if (devolverFoco && !celular()) this.botaoAberto?.focus({ preventScroll: true });
      this.aberto = null;
      this.rascunho = null;
      if (this.empurrou && !peloVoltar) {
        this.empurrou = false;
        this.ignorarPop = true;
        history.back();
      }
    }

    /* Gaveta do celular: arrastar para baixo fecha */
    arrastar(el) {
      let y0 = null;
      let dy = 0;
      el.addEventListener(
        'touchstart',
        (e) => {
          if (!celular() || !this.aberto || !this.aberto.contains(el)) return;
          y0 = e.touches[0].clientY;
          dy = 0;
          this.aberto.classList.add('is-arrastando');
        },
        { passive: true }
      );
      el.addEventListener(
        'touchmove',
        (e) => {
          if (y0 === null || !this.aberto) return;
          dy = Math.max(0, e.touches[0].clientY - y0);
          this.aberto.style.transform = `translateY(${dy}px)`;
        },
        { passive: true }
      );
      el.addEventListener('touchend', () => {
        if (y0 === null || !this.aberto) return;
        this.aberto.classList.remove('is-arrastando');
        if (dy > 90) this.fechar(true);
        else this.aberto.style.transform = '';
        y0 = null;
      });
    }

    /* ---------- Casa e Preço (listas com caixas de marcar) ---------- */
    contarLista() {
      const painel = this.aberto;
      if (!painel || !this.perfumes || !this.rascunho || painel.dataset.painel === 'uso') return;
      const grupo = painel.dataset.painel;
      this.rascunho[grupo] = [...painel.querySelectorAll('[data-grupo]:checked')].map((i) => i.value);
      const base = this.filtrar(this.rascunho, grupo);
      const conta = (v) =>
        grupo === 'casa'
          ? base.filter((p) => p.b === v).length
          : base.filter((p) => p.pr >= FAIXA[v].min && p.pr < FAIXA[v].max).length;
      painel.querySelectorAll('[data-grupo]').forEach((i) => {
        const n = conta(i.value);
        const label = i.closest('label');
        label.querySelector('[data-num]').textContent = n;
        label.classList.toggle('is-zero', n === 0 && !i.checked);
      });
      this.mostrarContagem(painel.querySelector('[data-contagem]'), this.filtrar(this.rascunho).length, painel);
    }

    buscarCasa(termo) {
      const t = sem(termo);
      this.querySelectorAll('[data-casa-item]').forEach((li) => {
        li.hidden = Boolean(t) && !sem(li.dataset.casaItem).includes(t);
      });
    }

    /* ---------- Filtrar por uso ---------- */
    desenharEtapa() {
      const e = ETAPAS[this.passo];
      const s = this.rascunho;
      const base = this.filtrar(s, e.id);
      const por = {};
      base.forEach((p) => p._v[e.id].forEach((v) => (por[v] = (por[v] || 0) + 1)));
      const opcoes = e.ordem.filter((v) => por[v] || s[e.id].includes(v));
      const rot = e.rotulo || ((v) => v);

      this.querySelector('[data-etapa-n]').textContent = `Etapa ${this.passo + 1} de ${ETAPAS.length}`;
      [...this.progresso.children].forEach((li, i) => li.classList.toggle('is-feito', i <= this.passo));
      this.etapaEl.innerHTML = `
        <h3>${esc(e.titulo)}</h3>
        <p>${esc(e.texto)}</p>
        ${
          opcoes.length
            ? `<ul class="anina-filtro__opcoes" role="list">${opcoes
                .map(
                  (v) =>
                    `<li><button type="button" class="anina-filtro__opcao" data-opcao="${esc(v)}" aria-pressed="${s[e.id].includes(v)}">${ICONE[v] || ''}${esc(rot(v))} <small>${por[v] || 0}</small></button></li>`
                )
                .join('')}</ul>`
            : '<p class="anina-filtro__sem">Nenhuma opção com as escolhas anteriores. Volte e ajuste, ou pule esta etapa.</p>'
        }
        ${e.nota ? `<p class="anina-filtro__nota">${esc(e.nota)}</p>` : ''}`;

      const ultima = this.passo === ETAPAS.length - 1;
      this.querySelector('[data-voltar]').disabled = this.passo === 0;
      this.querySelector('[data-pular]').hidden = ultima;
      const n = this.filtrar(s).length;
      const prox = this.querySelector('[data-proxima]');
      prox.textContent = ultima ? `Ver ${plural(n)}` : 'Próxima';
      prox.disabled = ultima && n === 0;
      this.mostrarContagem(this.querySelector('[data-contagem-uso]'), n);
    }

    mostrarContagem(el, n, painel) {
      el.textContent = n === 0 ? 'Nenhum perfume com essa combinação' : `${plural(n)} com essa combinação`;
      const aplicar = painel?.querySelector('[data-aplicar]');
      if (aplicar) {
        aplicar.textContent = n === 0 ? 'Ver perfumes' : `Ver ${plural(n)}`;
        aplicar.disabled = n === 0;
      }
    }

    alternarOpcao(valor) {
      const e = ETAPAS[this.passo];
      const marc = this.rascunho[e.id];
      const i = marc.indexOf(valor);
      if (i >= 0) marc.splice(i, 1);
      else marc.push(valor);
      /* escolhas das próximas etapas que deixaram de existir saem */
      for (let k = this.passo + 1; k < ETAPAS.length; k++) {
        const prox = ETAPAS[k];
        const base = this.filtrar(this.rascunho, prox.id);
        this.rascunho[prox.id] = this.rascunho[prox.id].filter((v) => base.some((p) => p._v[prox.id].includes(v)));
      }
      this.desenharEtapa();
      this.etapaEl.querySelector(`[data-opcao="${CSS.escape(valor)}"]`)?.focus({ preventScroll: true });
    }

    /* ---------- Aplicar e mostrar ---------- */
    aplicar() {
      this.aplicado = this.copia(this.rascunho);
      this.mostrando = POR_PAGINA;
      const seguir = () => {
        this.escreverUrl();
        this.atualizar(true);
      };
      this.fechar(true);
      /* history.back() do celular é assíncrono: grava a URL só depois dele */
      if (this.ignorarPop) {
        this.depoisPop = seguir;
        this.esperaPop = setTimeout(() => {
          if (!this.ignorarPop) return;
          this.ignorarPop = false;
          this.depoisPop = null;
          seguir();
        }, 600);
      } else seguir();
    }

    mudar(grupo, valor, ligar) {
      this.aplicado = this.resolver(this.aplicado);
      const atual = this.aplicado[grupo];
      if (ligar && !atual.includes(valor)) atual.push(valor);
      if (!ligar) this.aplicado[grupo] = atual.filter((v) => v !== valor);
      this.mostrando = POR_PAGINA;
      this.escreverUrl();
      this.atualizar(true);
    }

    limparTudo() {
      this.aplicado = this.vazioEstado();
      this.escreverUrl();
      this.atualizar();
    }

    acharGrade() {
      let el = this.abaixo?.nextElementSibling;
      while (el) {
        if (el.querySelector('.product-grid, [data-testid="product-grid"]')) return el;
        el = el.nextElementSibling;
      }
      return null;
    }

    atualizarBotoes() {
      const s = this.aplicado;
      const nUso = ETAPAS.reduce((t, e) => t + s[e.id].length, 0);
      [
        ['casa', s.casa.length],
        ['uso', nUso],
        ['preco', s.preco.length],
      ].forEach(([qual, n]) => {
        const q = this.querySelector(`[data-qtd="${qual}"]`);
        if (!q) return;
        /* Casa mostra o nome da marca no lugar do número */
        q.hidden = !n || (qual === 'casa' && n === 1);
        q.textContent = qual === 'casa' ? `+${n - 1}` : n;
        this.querySelector(`[data-abrir="${qual}"]`).classList.toggle('is-ativo', n > 0);
      });
      const rot = this.querySelector('[data-rotulo="casa"]');
      if (rot) {
        if (!this.rotuloCasa) this.rotuloCasa = rot.textContent;
        rot.textContent = s.casa.length ? this.nomeCasa(s.casa[0]) : this.rotuloCasa;
      }
      this.atalhos.forEach((b) => {
        const [g, v] = b.dataset.atalho.split(':');
        b.setAttribute('aria-pressed', String(s[g].some((x) => chave(x) === chave(v))));
      });
    }

    nomeCasa(v) {
      const li = [...this.querySelectorAll('[data-casa-item]')].find((x) => chave(x.dataset.casaItem) === chave(v));
      return li ? li.dataset.casaItem : v;
    }

    mostrarAtalhos() {
      this.atalhos.forEach((b) => {
        const [g, v] = b.dataset.atalho.split(':');
        b.hidden = !this.perfumes.some((p) => p._v[g]?.includes(v));
      });
    }

    atualizar(rolar) {
      this.aplicado = this.resolver(this.aplicado);
      this.atualizarBotoes();
      if (this.perfumes) this.mostrarAtalhos();
      const ligado = this.temFiltro(this.aplicado);
      this.grade?.classList.toggle('anina-filtro-oculto', ligado);
      this.resultados.hidden = !ligado;
      this.ativosEl.hidden = !ligado;
      const totais = [...this.querySelectorAll('[data-total-texto]'), ...this.abaixo.querySelectorAll('[data-total-texto]')];

      if (!ligado) {
        totais.forEach((t) => (t.textContent = plural(this.total)));
        this.ativosEl.innerHTML = '';
        this.lista.innerHTML = '';
        return;
      }

      const achados = this.ordenar_lista(this.filtrar(this.aplicado));
      this.ordenados = [...achados.filter((p) => p.av), ...achados.filter((p) => !p.av)];
      const n = this.ordenados.length;
      totais.forEach((t) => (t.textContent = `${n} de ${plural(this.total)}`));

      const x = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      const chips = [];
      GRUPOS.forEach((g) =>
        this.aplicado[g].forEach((v) => {
          const r = this.rotuloDe(g, v);
          chips.push(
            `<button type="button" class="anina-filtro__chip" data-remover="${g}" data-valor="${esc(v)}" aria-label="Remover ${esc(r)}">${esc(r)}${x}</button>`
          );
        })
      );
      chips.push('<button type="button" class="anina-filtro__link" data-limpar-tudo>Limpar tudo</button>');
      this.ativosEl.innerHTML = chips.join('');

      this.vazio.hidden = n > 0;
      if (n === 0) this.sugerir();
      this.desenharLista(true);
      /* Se a lista começa acima da tela, sobe até ela */
      if (rolar) {
        const falta = this.abaixo.getBoundingClientRect().top - (this.topo || 0) - this.offsetHeight - 8;
        if (falta < 0) rolagem().scrollBy({ top: falta, behavior: reduzir() ? 'auto' : 'smooth' });
      }
    }

    /* Resultado vazio: mostra o que destrava a busca */
    sugerir() {
      const opcoes = [];
      GRUPOS.forEach((g) =>
        this.aplicado[g].forEach((v) => {
          const s = this.copia(this.aplicado);
          s[g] = s[g].filter((x) => x !== v);
          const n = this.filtrar(s).length;
          if (n > 0) opcoes.push({ g, v, n });
        })
      );
      opcoes.sort((a, b) => b.n - a.n);
      this.sugestoes.innerHTML = opcoes
        .slice(0, 3)
        .map(
          (o) =>
            `<button type="button" class="anina-filtro__sugestao" data-remover="${o.g}" data-valor="${esc(o.v)}">Sem “${esc(this.rotuloDe(o.g, o.v))}”: <strong>${plural(o.n)}</strong></button>`
        )
        .join('');
    }

    ordenar_lista(itens) {
      const o = this.ordemAtual;
      const l = [...itens];
      const nome = (a, b) => a.t.localeCompare(b.t, 'pt-BR');
      if (o === 'price-ascending') l.sort((a, b) => a.pr - b.pr);
      else if (o === 'price-descending') l.sort((a, b) => b.pr - a.pr);
      else if (o === 'title-ascending') l.sort(nome);
      else if (o === 'title-descending') l.sort((a, b) => nome(b, a));
      else if (o === 'created-descending') l.sort((a, b) => (b.cr || 0) - (a.cr || 0));
      else if (o === 'created-ascending') l.sort((a, b) => (a.cr || 0) - (b.cr || 0));
      else l.sort((a, b) => a._ordem - b._ordem);
      return l;
    }

    ordenar(valor) {
      [this, this.abaixo].forEach((r) => r.querySelectorAll('[data-ordem]').forEach((s) => (s.value = valor)));
      const url = new URL(location.href);
      url.searchParams.set('sort_by', valor);
      url.searchParams.delete('page');
      /* Com filtro ligado, reordena na hora; sem filtro, a grade da coleção vem do servidor */
      if (this.temFiltro(this.aplicado) && this.perfumes) {
        this.ordemAtual = valor;
        history.replaceState(history.state, '', url.pathname + url.search.replace(/%2C/gi, ','));
        this.atualizar();
        return;
      }
      location.href = url.href;
    }

    desenharLista(animar) {
      const anterior = animar ? 0 : this.lista.children.length;
      const itens = this.ordenados.slice(0, this.mostrando);
      this.lista.innerHTML = itens
        .map((p, i) => {
          const novo = i >= anterior && !reduzir();
          return `<li class="anina-grid__item${novo ? ' is-entrando' : ''}"${novo ? ` style="--i:${Math.min(i - anterior, 8)}"` : ''}>${this.card(p)}</li>`;
        })
        .join('');
      this.mais.hidden = this.ordenados.length <= this.mostrando;
      if (!this.mais.hidden) this.mais.textContent = `Mostrar mais (${this.ordenados.length - this.mostrando})`;
    }

    estrelas(nota, qtd) {
      const pct = Math.max(0, Math.min(100, (Number(nota) / 5) * 100)).toFixed(1);
      const s = '<svg viewBox="0 0 24 24"><path d="M12 2.8l2.7 5.6 6.1.8-4.5 4.2 1.1 6.1L12 16.6l-5.4 2.9 1.1-6.1-4.5-4.2 6.1-.8z"/></svg>'.repeat(5);
      const txt = String(Math.round(Number(nota) * 10) / 10).replace('.', ',');
      return `<p class="anina-av-mini anina-card__av"><span class="anina-estrelas" style="--t: 12px; --p: ${pct}%;" role="img" aria-label="Nota ${txt} de 5"><span class="anina-estrelas__base" aria-hidden="true">${s}</span><span class="anina-estrelas__cheia" aria-hidden="true">${s}</span></span><span>(${qtd})</span></p>`;
    }

    card(p) {
      const meta = [p.k, p.vol ? `${p.vol} ml` : ''].filter(Boolean).join(' · ');
      const promo = p.cp && p.cp > p.pr;
      const off = promo ? Math.round(((p.cp - p.pr) * 100) / p.cp) : 0;
      const novo = p._tags.includes('Novidade');
      const preco = `${promo ? `<s class="anina-card__de"><span class="visually-hidden">De </span>${esc(this.moeda.format(p.cp / 100))}</s> <span class="visually-hidden">por </span>` : ''}${p.pv ? 'a partir de ' : ''}${esc(this.moeda.format((p.pr || 0) / 100))}`;
      const selo = !p.av
        ? '<span class="anina-badge anina-badge--muted">Esgotado</span>'
        : off > 0
          ? `<span class="anina-badge anina-badge--off">-${off}%</span>`
          : novo
            ? '<span class="anina-badge">Novidade</span>'
            : '';
      const sacola =
        '<svg class="anina-card__add-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l-1 12H7z M9 8V6.5a3 3 0 0 1 6 0V8 M12 11.5v5 M9.5 14h5"/></svg>';
      const comprar = !p.av
        ? ''
        : p.vc === 1
          ? `<div class="anina-card__quick"><anina-adicionar class="anina-card__quick-form"><form action="/cart/add" method="post" data-anina-add><input type="hidden" name="id" value="${esc(p.id)}"><input type="hidden" name="quantity" value="1"><button type="submit" class="anina-card__add" aria-label="Adicionar ${esc(p.t)} à sacola">${sacola}<span class="anina-combinam__add-texto anina-card__add-texto">Adicionar</span></button></form></anina-adicionar></div>`
          : `<div class="anina-card__quick"><a class="anina-card__add" href="${esc(p.u)}" aria-label="Ver opções de ${esc(p.t)}">${sacola}<span class="anina-card__add-texto">Ver opções</span></a></div>`;
      const img = p.im || p.img;
      return `<article class="anina-card${p.av ? '' : ' anina-card--soldout'}">
        <a href="${esc(p.u)}" class="anina-card__link">
          <div class="anina-card__media">
            ${img ? `<img src="${esc(img)}" alt="${esc(p.t)}" width="720" height="720" loading="lazy" class="anina-card__img anina-card__img--1">` : ''}
            <div class="anina-card__badges">${selo}</div>
          </div>
          <div class="anina-card__info">
            <p class="anina-card__vendor">${esc(p.b)}</p>
            <h3 class="anina-card__title">${esc(p.t)}</h3>
            ${meta ? `<p class="anina-card__meta">${esc(meta)}</p>` : ''}
            ${p.rc > 0 ? this.estrelas(p.rt, p.rc) : ''}
            <p class="anina-card__price">${preco}</p>
          </div>
        </a>
        ${comprar}
      </article>`;
    }

    /* ---------- Cliques ---------- */
    clique(ev) {
      const t = ev.target;
      const abrir = t.closest('[data-abrir]');
      if (abrir) return this.abrir(abrir.dataset.abrir);
      if (t.closest('[data-fechar]') || t.closest('[data-fundo]')) return this.fechar(true);
      if (t.closest('[data-aplicar]')) return this.aplicar();
      if (t.closest('[data-limpar-tudo]')) return this.limparTudo();
      if (t.closest('[data-mais]')) {
        this.mostrando += POR_PAGINA;
        return this.desenharLista(false);
      }
      const rem = t.closest('[data-remover]');
      if (rem) return this.mudar(rem.dataset.remover, rem.dataset.valor, false);
      const at = t.closest('[data-atalho]');
      if (at) {
        const [g, v] = at.dataset.atalho.split(':');
        return this.carregar().then(() => this.mudar(g, v, at.getAttribute('aria-pressed') !== 'true'));
      }
      if (t.closest('[data-limpar-lista]')) {
        this.aberto?.querySelectorAll('[data-grupo]').forEach((i) => (i.checked = false));
        return this.contarLista();
      }
      if (!this.rascunho) return;
      const op = t.closest('[data-opcao]');
      if (op) return this.alternarOpcao(op.dataset.opcao);
      if (t.closest('[data-limpar-uso]')) {
        ETAPAS.forEach((e) => (this.rascunho[e.id] = []));
        this.passo = 0;
        return this.desenharEtapa();
      }
      if (t.closest('[data-voltar]')) {
        this.passo = Math.max(0, this.passo - 1);
        return this.desenharEtapa();
      }
      if (t.closest('[data-pular]')) {
        this.rascunho[ETAPAS[this.passo].id] = [];
        this.passo = Math.min(ETAPAS.length - 1, this.passo + 1);
        return this.desenharEtapa();
      }
      if (t.closest('[data-proxima]')) {
        if (this.passo === ETAPAS.length - 1) return this.aplicar();
        this.passo += 1;
        return this.desenharEtapa();
      }
    }
  }

  customElements.define('anina-filtro', AninaFiltro);
})();
